import { ApolloClient } from '@apollo/client/core';
import { invoiceFragment } from 'apollo/fragments';
import { Invoice } from 'models/invoice';

export const writeInvoiceToCache = (client: ApolloClient<unknown>, invoice: Partial<Invoice>): void => {
    const id = `Invoice:${invoice._id}`;
    client.writeFragment({
        id,
        fragment: invoiceFragment,
        data: invoice,
        fragmentName: 'invoiceFields',
    });
};
